import { render } from "./multiQuote.vue?vue&type=template&id=15a3b124&scoped=true&lang=true"
import script from "./multiQuote.vue?vue&type=script&lang=js"
export * from "./multiQuote.vue?vue&type=script&lang=js"

import "./multiQuote.vue?vue&type=style&index=0&id=15a3b124&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a3b124"]])

export default __exports__